/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let deleteDataListApiUrl =  root.deleteDataListApiUrl.link;
let dataDeleteApiUrl =  root.dataDeleteApiUrl.link;
let dataRestoreApiUrl =  root.dataRestoreApiUrl.link;
export default {
  state: {
  },
  mutations: {
  },
  actions: {
    deletedDataListAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.get(deleteDataListApiUrl + "?is_deleted=True").then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    dataDeleteByIdAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.post(dataDeleteApiUrl + "?id=" + payload.id).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    dataRestoreByIdAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.post(dataRestoreApiUrl + "?id=" + payload.id).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
  }
}